import { TuitionPlanFrequency } from './TuitionPlan.types';

export const MonthlyTuitionPlanFrequencies = [TuitionPlanFrequency.Monthly, TuitionPlanFrequency.MonthlyExtended];
